export enum EnrolmentStatus {
  Confirmed = 0,
  Pending = 1,
  Rejected = 2,
  WaitListed = 3,
  Withdrawn = 4,
}
